
// DATAVIZ ###############################################################

const shoeAvatarPlugin = {
id: 'shoeAvatarPlugin',
afterDatasetsDraw(chart, args, opts) {
    const ctx = chart.ctx;
    const datasetIndex = opts.datasetIndex;
    const size = opts.size || 50;

    const dataset = chart.data.datasets[datasetIndex];
    const meta = chart.getDatasetMeta(datasetIndex);

    // Hauteur constante juste au-dessus de l’axe X
    const yFixed = chart.scales.y.bottom - (opts.offsetY || 30);  
    // offsetY = distance au-dessus de l’axe X

    dataset.data.forEach((value, i) => {
    const img = dataset._images[i];
    if (!img) return;

    const point = meta.data[i];
    if (!point) return;

    // x = aligné sur la date
    const x = point.x;

    // y = fixe (pas la hauteur du point)
    const y = yFixed;

    const half = size / 2;

    ctx.save();

    // clip circulaire
    ctx.beginPath();
    ctx.arc(x, y, half, 0, Math.PI * 2);
    ctx.closePath();
    ctx.clip();

    // fond gris clair
    ctx.fillStyle = "#E2E8F0";
    ctx.fillRect(x - half, y - half, size, size);

    // image de chaussure
    ctx.drawImage(img, x - half, y - half, size, size);

    ctx.restore();

    // bordure
    ctx.beginPath();
    ctx.arc(x, y, half, 0, Math.PI * 2);
    ctx.strokeStyle = "rgba(0, 26, 20, 0.15)";
    ctx.lineWidth = 2;
    ctx.stroke();
    });
}
};

const shoeGuidesPlugin = {
id: "shoeGuidesPlugin",
beforeDatasetsDraw(chart, args, opts) {
    const datasetIndex = opts.datasetIndex;
    const dataset = chart.data.datasets[datasetIndex];
    const meta = chart.getDatasetMeta(datasetIndex);

    const ctx = chart.ctx;
    const size = opts.markerSize || 50;
    const imgOffsetY = opts.offsetY || 40;

    // Hauteur fixe de l'image (même que dans shoeAvatarPlugin)
    const imageY = chart.scales.y.bottom - imgOffsetY;

    dataset.data.forEach((val, i) => {
    const point = meta.data[i];
    if (!point) return;

    const x = point.x;
    const pointY = point.y;     // hauteur réelle de la mesure

    ctx.save();
    ctx.strokeStyle = opts.color || "rgba(0,0,0,0.25)";
    ctx.lineWidth = 1;
    ctx.setLineDash([4, 3]);

    // --- ligne verticale : uniquement entre l’image et le point ---
    ctx.beginPath();
    ctx.moveTo(x, imageY);      // démarre à l’image
    ctx.lineTo(x, pointY);      // s’arrête au niveau du point
    ctx.stroke();

    // --- ligne horizontale classique ---
    ctx.beginPath();
    ctx.moveTo(chart.scales.x.left, pointY);
    ctx.lineTo(chart.scales.x.right, pointY);
    ctx.stroke();

    ctx.restore();
    });
}
};

// Change time range
function mmFilterByRange(range, data) {
const now = new Date();

if (range === "6m") {
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(now.getMonth() - 6);

    const inside = data.filter(item => new Date(item.date) >= sixMonthsAgo);

    // Trouver le dernier point juste avant la fenêtre
    const before = data
    .filter(item => new Date(item.date) < sixMonthsAgo)
    .sort((a,b) => new Date(b.date) - new Date(a.date))[0];

    if (before) {
    return [ before, ...inside ];
    }
    return inside;
}

return data;  // full
}


// KLAVIYO #############################################################

var MM_KLAVIYO_MAX_KIDS = 5;

function mmKlaviyoSyncProfile() {
    var _learnq = window._learnq || [];
    var root = document.querySelector("#mm-cc-root");
    if (!root) return;

    var email = root.dataset.customerEmail;
    if (!email) return;

    var kids = [];
    try {
        kids = JSON.parse(root.dataset.kidsJson || "[]");
    } catch (e) {
        console.warn("Klaviyo sync: invalid kids JSON", e);
    }

    var youngestBirthday = "";
    var lastMeasureDate = "";

    kids.forEach(function(kid) {
        if (kid.birthday && (!youngestBirthday || kid.birthday > youngestBirthday)) {
            youngestBirthday = kid.birthday;
        }
        if (kid.last_measure_date && (!lastMeasureDate || kid.last_measure_date > lastMeasureDate)) {
            lastMeasureDate = kid.last_measure_date;
        }
    });

    var profileData = {
        "$email": email,
        "$first_name": root.dataset.customerFirstName || "",
        "$last_name": root.dataset.customerLastName || "",
        "children_count": kids.length,
        "has_child_profile": kids.length > 0,
        "youngest_child_birthday": youngestBirthday,
        "last_measure_date": lastMeasureDate,
        "children": []
    };

    // Champs plats par enfant (enfant_1_* à enfant_5_*)
    for (var i = 0; i < MM_KLAVIYO_MAX_KIDS; i++) {
        var kid = kids[i] || {};
        var prefix = "enfant_" + (i + 1) + "_";
        profileData[prefix + "first_name"] = kid.first_name || "";
        profileData[prefix + "birthday"] = kid.birthday || "";
        profileData[prefix + "last_measure_date"] = kid.last_measure_date || "";
    }

    _learnq.push(["identify", profileData]);
}

function mmKlaviyoTrackEvent(eventName, properties) {
    var _learnq = window._learnq || [];
    _learnq.push(["track", eventName, properties || {}]);
}

// FRONT ###############################################################

function mmOpenMeasurePopup(childId) {
    if (childId) {
        const root = document.querySelector("#mm-cc-root");
        if (root) root.dataset.currentChildId = childId;
    }
    const popup = document.querySelector('.mm-cc-popup-ajout-mesure-wrapper');
    if (!popup) return;
    // Set default date to today
    const dateInput = popup.querySelector('[data-field="measure-date"]');
    if (dateInput) {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        dateInput.value = `${yyyy}-${mm}-${dd}`;
    }
    popup.classList.add('mm-visible');
}
function mmCloseMeasurePopup() {
    const popup = document.querySelector('.mm-cc-popup-ajout-mesure-wrapper');
    if (!popup) return;
    popup.classList.remove('mm-visible');
}
function mmOpenChildPopup() {
    const popup = document.querySelector('.mm-cc-popup-ajout-enfant-wrapper');
    if (!popup) return;
    popup.classList.add('mm-visible');
    document.body.style.overflow = 'hidden';
    mmInitChildPopupKeyboardFix(popup);
}
function mmInitChildPopupKeyboardFix(wrapper) {
    const popup = wrapper.querySelector('.mm-cc-popup-ajout-enfant');
    if (!popup || !window.visualViewport) return;

    function updatePopupPosition() {
        const vv = window.visualViewport;
        popup.style.height = vv.height + 'px';
        popup.style.top = vv.offsetTop + 'px';
        window.scrollTo(0, 0);
    }

    function onInputFocus(e) {
        setTimeout(() => {
            updatePopupPosition();
            e.target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 300);
    }

    window.visualViewport.addEventListener('resize', updatePopupPosition);
    window.visualViewport.addEventListener('scroll', updatePopupPosition);

    const inputs = popup.querySelectorAll('[data-field="child-first-name"], [data-field="child-birthday"]');
    inputs.forEach(input => input.addEventListener('focus', onInputFocus));

    wrapper._mmKeyboardCleanup = () => {
        window.visualViewport.removeEventListener('resize', updatePopupPosition);
        window.visualViewport.removeEventListener('scroll', updatePopupPosition);
        inputs.forEach(input => input.removeEventListener('focus', onInputFocus));
        popup.style.height = '';
        popup.style.top = '';
    };
}

function mmCloseChildPopup() {
    const popup = document.querySelector('.mm-cc-popup-ajout-enfant-wrapper');
    if (!popup) return;
    if (popup._mmKeyboardCleanup) {
        popup._mmKeyboardCleanup();
        delete popup._mmKeyboardCleanup;
    }
    document.body.style.overflow = '';
    popup.classList.remove('mm-visible');

    // Reset form and validation on close
    mmResetChildForm();
}

function mmResetChildForm() {
    const wrapper = document.querySelector(".mm-cc-popup-ajout-enfant-wrapper");
    if (!wrapper) return;

    // Reset fields
    const radios = wrapper.querySelectorAll('input[name="mm_add_child_characters"]');
    radios.forEach(r => r.checked = false);

    const nameInput = wrapper.querySelector('[data-field="child-first-name"]');
    if (nameInput) nameInput.value = '';

    const birthdayInput = wrapper.querySelector('[data-field="child-birthday"]');
    if (birthdayInput) birthdayInput.value = '';

    // Disable buttons
    mmValidateChildForm();
}

function mmValidateChildForm() {
    const wrapper = document.querySelector(".mm-cc-popup-ajout-enfant-wrapper");
    if (!wrapper) return;

    const persona = wrapper.querySelector('input[name="mm_add_child_characters"]:checked')?.value || "";
    const firstName = wrapper.querySelector('[data-field="child-first-name"]')?.value?.trim() || "";
    const birthday = wrapper.querySelector('[data-field="child-birthday"]')?.value || "";

    const isValid = persona && firstName && birthday;

    const mainBtn = wrapper.querySelector('[data-child-submit]');
    const secondaryBtn = wrapper.querySelector('[data-child-submit-secondary]');

    if (mainBtn) mainBtn.disabled = !isValid;
    if (secondaryBtn) secondaryBtn.disabled = !isValid;
}

function mmOpenMeasureVideo() {
    const videoContainer = document.querySelector('.mm-cc-popup-ajout-mesure-video-wrapper');
    if (!videoContainer) return;
    const video = videoContainer.querySelector('video');
    if (!video) return;
    const source = video.querySelector('source');
    if (!source) return;

    videoContainer.classList.add('mm-visible');
    source.src = source.dataset.src;
    video.load();
    video.play();
}
function mmCloseMeasureVideo() {
    const videoContainer = document.querySelector('.mm-cc-popup-ajout-mesure-video-wrapper');
    if (!videoContainer) return;
    const video = videoContainer.querySelector('video');
    if (!video) return;
    const source = video.querySelector('source');
    if (!source) return;

    videoContainer.classList.remove('mm-visible');
    video.pause();
    video.currentTime = 0;
}

function mmOpenProfileInfos(kidName) {

    history.pushState(
        { customState: `child-${kidName}` },
        "",
        `/pages/courbe-de-croissance?child=${kidName}`
    );
    mmSetupChildInfos(kidName);
}

function mmGoBack() {
    history.back();
}

function mmSetupChildInfos(kidName) {

    const allElems = document.querySelectorAll(`[data-child]`);
    allElems.forEach(function(elem) {
        elem.classList.add('mm-none');
    })

    const elemsToShow = document.querySelectorAll(`[data-child='${kidName}']`);
    elemsToShow.forEach(function(elemToShow) {
        elemToShow.classList.remove('mm-none');
    })

    // Cache la bannière principale quand on affiche un enfant
    const mainBanner = document.querySelector(`[data-main-banner]`);
    if (mainBanner) mainBanner.classList.add('mm-none');

    // Ces éléments n'existent que s'il y a des enfants
    const historyEl = document.querySelector(`[data-history]`);
    if (historyEl) historyEl.classList.remove('mm-none');

    // Cache tous les boutons "voir le profil"
    document.querySelectorAll(`[data-see-profile]`).forEach(el => {
        el.classList.add('mm-none');
    });

    // Affiche le bouton "supprimer cet enfant"
    document.querySelectorAll(`[data-delete-child]`).forEach(el => {
        el.classList.remove('mm-none');
    });

    // Redimensionner les charts après le changement de layout
    setTimeout(() => {
        if (window.mmCharts) {
            Object.values(window.mmCharts).forEach(chart => {
                if (chart && typeof chart.resize === 'function') {
                    chart.resize();
                }
            });
        }
    }, 50);
}

window.addEventListener("popstate", (event) => {
  const params = new URLSearchParams(window.location.search);
  const kidName = params.get("child");

  if (kidName) {
    mmSetupChildInfos(kidName);
  } else {
    mmResetChildInfos();
  }
});

function mmResetChildInfos() {

    const allElems = document.querySelectorAll(`[data-child]`);
    allElems.forEach(function(elem) {
        elem.classList.add('mm-none');
    })

    const elemsToShow = document.querySelectorAll(`[data-show-onload]`);
    elemsToShow.forEach(function(elemToShow) {
        elemToShow.classList.remove('mm-none');
    })

    // Réaffiche la bannière principale
    const mainBanner = document.querySelector(`[data-main-banner]`);
    if (mainBanner) mainBanner.classList.remove('mm-none');

    // Ces éléments n'existent que s'il y a des enfants
    const historyEl = document.querySelector(`[data-history]`);
    if (historyEl) historyEl.classList.add('mm-none');

    // Réaffiche tous les boutons "voir le profil"
    document.querySelectorAll(`[data-see-profile]`).forEach(el => {
        el.classList.remove('mm-none');
    });

    // Cache le bouton "supprimer cet enfant"
    document.querySelectorAll(`[data-delete-child]`).forEach(el => {
        el.classList.add('mm-none');
    });

    // Redimensionner les charts après le changement de layout
    setTimeout(() => {
        if (window.mmCharts) {
            Object.values(window.mmCharts).forEach(chart => {
                if (chart && typeof chart.resize === 'function') {
                    chart.resize();
                }
            });
        }
    }, 50);
}

document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const kidName = params.get("child");

  if (kidName) {
    mmSetupChildInfos(kidName);
  } else {
    // S'assurer que la bannière principale est visible quand pas d'enfant sélectionné
    const mainBanner = document.querySelector(`[data-main-banner]`);
    if (mainBanner) mainBanner.classList.remove('mm-none');
  }
});

// MIDDLEWARE ###############################################################

/**
 * Dashboard mesures - calls API PPDG
 * Base URL: https://ppdg-chart.netlify.app
 * Token: POST /api/token (valable 1h)
 * Auth: Authorization: Bearer <token>
 */

(function () {
  const ROOT_SELECTOR = "#mm-cc-root";

  function getRoot() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function getApiBase() {
    const root = getRoot();
    return root?.dataset?.apiBase?.replace(/\/$/, "") || "";
  }

  function getCustomerId() {
    const root = getRoot();
    const id = root?.dataset?.customerId;
    return id ? Number(id) : null;
  }

  function getToken() {
    return getRoot()?.dataset?.token || "";
  }

  function setToken(token, expireAtMs) {
    const root = getRoot();
    if (!root) return;
    root.dataset.token = token || "";
    root.dataset.tokenExpireAt = String(expireAtMs || "");
  }

  function tokenIsValid() {
    const root = getRoot();
    if (!root) return false;
    const token = root.dataset.token || "";
    const expireAt = Number(root.dataset.tokenExpireAt || "0");
    if (!token || !expireAt) return false;
    // marge 30s
    return Date.now() < expireAt - 30_000;
  }

  function setCurrentChildId(childId) {
    const root = getRoot();
    if (!root) return;
    root.dataset.currentChildId = childId || "";
  }

  function getCurrentChildId() {
    return getRoot()?.dataset?.currentChildId || "";
  }

  function showError(err) {
    // Remplace par ton UI (message sous champ, toast etc.)
    console.error(err);
    alert(err?.message || "Une erreur est survenue.");
  }

  async function fetchJson(url, { method = "GET", headers = {}, body = null } = {}) {
    const opts = {
      method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...headers,
      },
      body: body ? JSON.stringify(body) : undefined,
    };

    const res = await fetch(url, opts);

    const text = await res.text();
    let data = null;
    if (text) {
      try {
        data = JSON.parse(text);
      } catch {
        data = text;
      }
    }

    if (!res.ok) {
      const msg =
        (data && typeof data === "object" && data.message) ||
        `HTTP ${res.status} ${res.statusText}`;
      const error = new Error(msg);
      error.status = res.status;
      error.data = data;
      throw error;
    }

    return data;
  }

  async function ensureToken() {
    const apiBase = getApiBase();
    const customerId = getCustomerId();

    if (!apiBase) throw new Error("API base manquante (data-api-base).");
    if (!customerId) throw new Error("Customer non connecté (customer.id manquant).");

    if (tokenIsValid()) return getToken();

    const data = await fetchJson(`${apiBase}/api/token`, {
      method: "POST",
      body: { customerId },
    });

    // Ton API “renvoie un token” : je ne connais pas le shape exact.
    // On supporte plusieurs formats classiques.
    const token =
      (typeof data === "string" && data) ||
      data?.token ||
      data?.jwt ||
      data?.access_token;

    if (!token) throw new Error("Réponse /api/token inattendue (token introuvable).");

    // valable 1h (info donnée) => expireAt = now + 1h
    const expireAtMs = Date.now() + 60 * 60 * 1000;
    setToken(token, expireAtMs);
    return token;
  }

  async function authedPost(path, payload) {
    const apiBase = getApiBase();
    const token = await ensureToken();

    try {
      return await fetchJson(`${apiBase}${path}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: payload,
      });
    } catch (err) {
      // si 401, on retente une fois après refresh token
      if (err?.status === 401) {
        setToken("", 0);
        const refreshed = await ensureToken();
        return await fetchJson(`${apiBase}${path}`, {
          method: "POST",
          headers: { Authorization: `Bearer ${refreshed}` },
          body: payload,
        });
      }
      throw err;
    }
  }

  async function authedDelete(path, payload) {
    const apiBase = getApiBase();
    const token = await ensureToken();

    try {
      return await fetchJson(`${apiBase}${path}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
        body: payload,
      });
    } catch (err) {
      // si 401, on retente une fois après refresh token
      if (err?.status === 401) {
        setToken("", 0);
        const refreshed = await ensureToken();
        return await fetchJson(`${apiBase}${path}`, {
          method: "DELETE",
          headers: { Authorization: `Bearer ${refreshed}` },
          body: payload,
        });
      }
      throw err;
    }
  }

  // -----------------------------
  // Read values from modals
  // -----------------------------
  function readAddChildForm() {
    const wrapper = document.querySelector(".mm-cc-popup-ajout-enfant-wrapper");
    if (!wrapper) throw new Error("Modale enfant introuvable.");

    const persona = wrapper.querySelector('input[name="mm_add_child_characters"]:checked')?.value || "";
    const firstName = wrapper.querySelector('[data-field="child-first-name"]')?.value?.trim() || "";
    const birthday = wrapper.querySelector('[data-field="child-birthday"]')?.value || "";

    if (!firstName) throw new Error("Le prénom est obligatoire.");
    if (!birthday) throw new Error("La date de naissance est obligatoire.");

    return { persona, firstName, birthday };
  }

  function readAddMeasureForm() {
    const wrapper = document.querySelector(".mm-cc-popup-ajout-mesure-wrapper");
    if (!wrapper) throw new Error("Modale mesure introuvable.");

    const leftLength = wrapper.querySelector('[data-field="left-length"]')?.value;
    const leftWidth = wrapper.querySelector('[data-field="left-width"]')?.value;
    const rightLength = wrapper.querySelector('[data-field="right-length"]')?.value;
    const rightWidth = wrapper.querySelector('[data-field="right-width"]')?.value;

    const toNum = (v) => {
      const n = Number(String(v ?? "").replace(",", "."));
      if (Number.isNaN(n)) return null;
      return n;
    };

    const payload = {
      leftLength: toNum(leftLength),
      leftWidth: toNum(leftWidth),
      rightLength: toNum(rightLength),
      rightWidth: toNum(rightWidth),
    };

    if (payload.leftLength == null || payload.leftWidth == null || payload.rightLength == null || payload.rightWidth == null) {
      throw new Error("Merci de renseigner toutes les mesures (valeurs numériques).");
    }

    return payload;
  }

  // -----------------------------
  // Public functions (called by onclick)
  // -----------------------------
  function setChildButtonsLoading(loading) {
    const wrapper = document.querySelector(".mm-cc-popup-ajout-enfant-wrapper");
    if (!wrapper) return;
    const btns = wrapper.querySelectorAll('[data-child-submit], [data-child-submit-secondary]');
    btns.forEach(btn => {
      btn.disabled = loading;
      if (loading) {
        btn.dataset.originalText = btn.textContent;
        btn.textContent = 'Chargement...';
        btn.classList.add('mm-loading');
      } else {
        if (btn.dataset.originalText) btn.textContent = btn.dataset.originalText;
        btn.classList.remove('mm-loading');
      }
    });
  }

  window.mmSubmitChildOnly = async function (skipReload = false) {
    try {
      setChildButtonsLoading(true);
      const { persona, firstName, birthday } = readAddChildForm();

      const result = await authedPost("/api/customer/child/upsert", {
        first_name: firstName,
        birthday,
        persona,
        chaussures_associees: [],
      });

      // Récupère le childId depuis la réponse (format: gid://shopify/Metaobject/123456)
      const fullId =
        result?.data?.metaobjectUpsert?.metaobject?.id ||
        result?.childId ||
        result?.id ||
        "";

      // Extrait l'ID numérique
      const childId = fullId ? fullId.split('/').pop() : "";

      if (!childId) {
        console.warn("Child créé/MAJ mais childId introuvable dans la réponse:", result);
      } else {
        setCurrentChildId(childId);
      }

      // Klaviyo: track child creation
      mmKlaviyoTrackEvent("Child Profile Created", {
        child_first_name: firstName,
        child_birthday: birthday
      });

      // ferme la modale enfant
      if (typeof window.mmCloseChildPopup === "function") window.mmCloseChildPopup();

      // Refresh page sauf si on enchaîne avec l'ajout de mesure
      if (!skipReload) {
        window.location.reload();
      }

      return childId;

    } catch (err) {
      setChildButtonsLoading(false);
      showError(err);
      return null;
    }
  };

  window.mmSubmitChildAndOpenMeasure = async function () {
    try {
      // Crée l'enfant sans reload
      const childId = await window.mmSubmitChildOnly(true);

      if (!childId) {
        throw new Error("Impossible d'ouvrir le formulaire de mesure : enfant non créé.");
      }

      // Ouvre la modale mesure avec le childId
      if (typeof window.mmOpenMeasurePopup === "function") {
        window.mmOpenMeasurePopup(childId);
      }
    } catch (err) {
      showError(err);
    }
  };

  function setMeasureButtonLoading(loading) {
    const wrapper = document.querySelector(".mm-cc-popup-ajout-mesure-wrapper");
    if (!wrapper) return;
    const btn = wrapper.querySelector('.mm-btn-primary');
    if (!btn) return;
    btn.disabled = loading;
    if (loading) {
      btn.dataset.originalText = btn.innerHTML;
      btn.innerHTML = 'Chargement...';
      btn.classList.add('mm-loading');
    } else {
      if (btn.dataset.originalText) btn.innerHTML = btn.dataset.originalText;
      btn.classList.remove('mm-loading');
    }
  }

  window.mmSubmitMeasure = async function () {
    try {
      setMeasureButtonLoading(true);
      const childId = getCurrentChildId();
      if (!childId) {
        throw new Error("Impossible d'ajouter une mesure : enfant non sélectionné (childId manquant).");
      }

      const measures = readAddMeasureForm();

      // Read date from the form
      const wrapper = document.querySelector(".mm-cc-popup-ajout-mesure-wrapper");
      const measureDate = wrapper?.querySelector('[data-field="measure-date"]')?.value || "";

      await authedPost("/api/customer/measure/upsert", {
        childId,
        date: measureDate,
        pied_gauche_longueur: measures.leftLength,
        pied_gauche_largeur: measures.leftWidth,
        pied_droit_longueur: measures.rightLength,
        pied_droit_largeur: measures.rightWidth,
      });

      // Klaviyo: track measure added
      mmKlaviyoTrackEvent("Child Measure Added", {
        child_id: childId,
        measure_date: measureDate,
        left_length: measures.leftLength,
        left_width: measures.leftWidth,
        right_length: measures.rightLength,
        right_width: measures.rightWidth
      });

      if (typeof window.mmCloseMeasurePopup === "function") window.mmCloseMeasurePopup();

      // Refresh page to show new data
      window.location.reload();

    } catch (err) {
      setMeasureButtonLoading(false);
      showError(err);
    }
  };

  window.mmDeleteMeasure = async function (measureId, btn) {
    if (!measureId) {
      console.error('Missing measureId');
      return;
    }

    // Confirmation
    if (!confirm('Êtes-vous sûr de vouloir supprimer cette mesure ?')) {
      return;
    }

    try {
      await authedDelete("/api/customer/measure/delete", {
        measureId: measureId
      });

      // Remove the line from UI
      const line = btn.closest('.mm-cc-mesures-line');
      if (line) {
        line.style.opacity = '0';
        line.style.transition = 'opacity 0.3s';
        setTimeout(() => {
          line.remove();
        }, 300);
      }

      // Show success toast
      const toast = document.createElement('div');
      toast.className = 'mm-cc-toast';
      toast.innerHTML = `
        <p>Mesure supprimée avec succès !</p>
        <p class="mm-text-xs">Le graphique sera mis à jour au prochain chargement.</p>
      `;
      document.body.appendChild(toast);

      setTimeout(() => {
        toast.remove();
      }, 5000);

    } catch (err) {
      showError(err);
    }
  };

  // -----------------------------
  // Delete child
  // -----------------------------

  window.mmDeleteChild = async function (childId, childName) {
    if (!childId) {
      console.error('Missing childId');
      return;
    }

    if (!confirm(`Êtes-vous sûr de vouloir supprimer le profil de ${childName} ? Cette action est irréversible et supprimera toutes les mesures associées.`)) {
      return;
    }

    try {
      await authedDelete("/api/customer/child/delete", {
        childId: childId
      });

      window.location.href = '/pages/courbe-de-croissance';

    } catch (err) {
      showError(err);
    }
  };

  // -----------------------------
  // Shoe-Child association
  // -----------------------------

  // Store pending association data
  let pendingAssociation = {
    kidId: null,
    kidName: null,
    itemId: null,
    btn: null
  };

  window.mmToggleAssociateDropdown = function (btn) {
    const dropdown = btn.closest('.mm-cc-orders-associate-dropdown');
    const menu = dropdown.querySelector('.mm-cc-orders-associate-menu');

    // Close all other dropdowns
    document.querySelectorAll('.mm-cc-orders-associate-menu').forEach(m => {
      if (m !== menu) m.classList.add('mm-none');
    });

    menu.classList.toggle('mm-none');
  };

  window.mmOpenAssociatePopup = function (kidId, kidName, itemId, btn) {
    // Store the pending association data
    pendingAssociation = { kidId, kidName, itemId, btn };

    // Get product info from the order line
    const line = btn.closest('.mm-cc-orders-line');
    const productTitle = line.querySelector('.mm-cc-orders-product-info .mm-text-sm-bold')?.textContent || '';
    const productVendor = line.querySelectorAll('.mm-cc-orders-product-info .mm-text-xs')[0]?.textContent || '';
    const productDate = line.querySelectorAll('.mm-cc-orders-product-info .mm-text-xs')[1]?.textContent || '';
    const productSize = line.querySelector('.mm-cc-orders-actions .mm-text-sm-bold')?.textContent || '';
    const productImage = line.querySelector('.mm-cc-orders-product-image img')?.src || '';

    // Populate the popup
    const popup = document.querySelector('.mm-cc-popup-associate-wrapper');
    if (!popup) return;

    // Update title with kid name
    const titleEl = popup.querySelector('[data-popup-title]');
    if (titleEl) {
      titleEl.textContent = `Êtes vous sûr de vouloir associer cette paire à ${kidName} ?`;
    }

    // Update subtitle
    const subtitleEl = popup.querySelector('[data-popup-subtitle]');
    if (subtitleEl) {
      subtitleEl.textContent = `Cette paire sera associée au profil de ${kidName}.`;
    }

    // Update product info
    const imgEl = popup.querySelector('[data-popup-product-image]');
    if (imgEl) imgEl.src = productImage;

    const titleProductEl = popup.querySelector('[data-popup-product-title]');
    if (titleProductEl) titleProductEl.textContent = productTitle;

    const vendorEl = popup.querySelector('[data-popup-product-vendor]');
    if (vendorEl) vendorEl.textContent = productVendor;

    const dateEl = popup.querySelector('[data-popup-product-date]');
    if (dateEl) dateEl.textContent = productDate;

    const sizeEl = popup.querySelector('[data-popup-product-size]');
    if (sizeEl) sizeEl.textContent = productSize;

    // Hide current association badge (not applicable for new associations)
    const currentAssocEl = popup.querySelector('[data-popup-current-association]');
    if (currentAssocEl) currentAssocEl.classList.add('mm-none');

    // Close dropdown and show popup
    document.querySelectorAll('.mm-cc-orders-associate-menu').forEach(m => {
      m.classList.add('mm-none');
    });
    popup.classList.add('mm-visible');
  };

  window.mmCloseAssociatePopup = function () {
    const popup = document.querySelector('.mm-cc-popup-associate-wrapper');
    if (popup) {
      popup.classList.remove('mm-visible');
    }
    // Reset pending association
    pendingAssociation = { kidId: null, kidName: null, itemId: null, btn: null };
  };

  window.mmConfirmAssociation = async function () {
    const { kidId, kidName, itemId, btn } = pendingAssociation;

    if (!kidId || !itemId) {
      console.error('Missing association data');
      return;
    }

    try {
      await authedPost("/api/customer/child/associate-shoe", {
        childId: kidId,
        shoeId: itemId
      });

      // Update UI to show association
      const line = btn.closest('.mm-cc-orders-line');
      const actionsDiv = line.querySelector('.mm-cc-orders-actions');
      const dropdown = actionsDiv.querySelector('.mm-cc-orders-associate-dropdown');

      // Replace dropdown with associated badge
      dropdown.outerHTML = `
        <span class="mm-cc-orders-associated mm-flex mm-align-center mm-gap-4">
          Associé à ${kidName}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3334 4L6.00008 11.3333L2.66675 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      `;

      // Close the popup and show success message
      mmCloseAssociatePopup();

      // Show toast message
      const toast = document.createElement('div');
      toast.className = 'mm-cc-toast';
      toast.innerHTML = `
        <p>Chaussure associée avec succès !</p>
        <p class="mm-text-xs">Rechargez la page pour voir la mise à jour sur le graphique.</p>
      `;
      document.body.appendChild(toast);

      // Remove toast after 5 seconds
      setTimeout(() => {
        toast.remove();
      }, 5000);

    } catch (err) {
      showError(err);
    }
  };

  // Keep legacy function for backwards compatibility
  window.mmAssociateShoeToChild = async function (kidId, kidName, itemId, btn) {
    // Open popup instead of directly associating
    mmOpenAssociatePopup(kidId, kidName, itemId, btn);
  };

  // -----------------------------
  // Shoe-Child disassociation
  // -----------------------------

  window.mmToggleDisassociateDropdown = function (btn) {
    const dropdown = btn.closest('.mm-cc-orders-disassociate-dropdown');
    const menu = dropdown.querySelector('.mm-cc-orders-disassociate-menu');

    // Close all other dropdowns (both associate and disassociate)
    document.querySelectorAll('.mm-cc-orders-associate-menu, .mm-cc-orders-disassociate-menu').forEach(m => {
      if (m !== menu) m.classList.add('mm-none');
    });

    menu.classList.toggle('mm-none');
  };

  window.mmDisassociateShoe = async function (kidId, shoeId, btn) {
    if (!kidId || !shoeId) {
      console.error('Missing disassociation data');
      return;
    }

    // Confirmation
    if (!confirm('Êtes-vous sûr de vouloir supprimer cette association ?')) {
      return;
    }

    try {
      await authedPost("/api/customer/child/disassociate-shoe", {
        childId: kidId,
        shoeId: shoeId
      });

      // Update UI - replace badge with success text
      const line = btn.closest('.mm-cc-orders-line');
      const actionsDiv = line.querySelector('.mm-cc-orders-actions');
      const disassociateDropdown = actionsDiv.querySelector('.mm-cc-orders-disassociate-dropdown');

      disassociateDropdown.outerHTML = `
        <span class="mm-text-sm" style="color: #10B981;">Désassociation réussie</span>
      `;

    } catch (err) {
      showError(err);
    }
  };

  // -----------------------------
  // Init on load: prefetch token (optional)
  // -----------------------------
  document.addEventListener("DOMContentLoaded", async () => {
    try {
      const root = getRoot();
      if (!root) return;

      // si user loggé, on peut précharger le token
      if (getCustomerId()) {
        await ensureToken();
      }

      // Klaviyo: sync profil avec données enfants à chaque chargement
      mmKlaviyoSyncProfile();

      // Setup association dropdowns
      document.querySelectorAll('.mm-cc-orders-associate-btn').forEach(btn => {
        btn.addEventListener('click', () => mmToggleAssociateDropdown(btn));
      });

      document.querySelectorAll('.mm-cc-orders-associate-option').forEach(option => {
        option.addEventListener('click', () => {
          const kidId = option.dataset.kidId;
          const kidName = option.dataset.kidName;
          const line = option.closest('.mm-cc-orders-line');
          const itemId = line.dataset.itemId;
          mmAssociateShoeToChild(kidId, kidName, itemId, option);
        });
      });

      // Close dropdowns when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.mm-cc-orders-associate-dropdown') && !e.target.closest('.mm-cc-orders-disassociate-dropdown')) {
          document.querySelectorAll('.mm-cc-orders-associate-menu, .mm-cc-orders-disassociate-menu').forEach(m => {
            m.classList.add('mm-none');
          });
        }
      });

    } catch (err) {
      // ne bloque pas la page si token KO (user peut ne pas être loggé)
      console.warn("Token init failed:", err);
    }
  });
})();

